await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/commerce-frontend-js/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import ClayDropDown from '@clayui/drop-down';
import React from 'react';

function EmptyListView({caption, loading}) {
	return (
		<ClayDropDown.Caption>
			{loading ? Liferay.Language.get('loading') : caption}
		</ClayDropDown.Caption>
	);
}

export default EmptyListView;
